// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__AOSzo","active":"Error_active__Xxrc-","close":"Error_close__LXu4U"};